import Vue from 'vue'
import VueRouter from 'vue-router'
import yearbook from '../views/Year_book.vue'
import yeabookClass from '../views/Year_book_class.vue'
import yearbookRouter from '../views/yearbook_router'
import Welcome from '../views/Welcome_screen.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'WelcomeScreen',
    component: Welcome,
    meta: {
      showHeader: false,
    },
  },
  {
    path: '/login',
    name: 'Login',
   
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue'),
    meta: {
      showHeader: false,
    },
  },
  {
    path: '/signup',
    name: 'SignUp',
   
    component: () => import(/* webpackChunkName: "about" */ '../views/SignUp.vue'),
    meta: {
      showHeader: false,
    },
  },
  {
    path: '/home',
    name: 'Home',
   
    component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue'),
    meta: {
      showHeader: true,
    },
  },
  {
    path: '/discussion',
    name: 'Discussion',
   
    component: () => import(/* webpackChunkName: "about" */ '../views/Discussion.vue'),
    meta: {
      showHeader: true,
    },
  },
 
  {
    path: '/group',
    name: 'Group',
   
    component: () => import(/* webpackChunkName: "about" */ '../views/Group.vue'),
    meta: {
      showHeader: true,
    },
  },
  {
    path: '/groupchat',
    name: 'Group Chat',
   
    component: () => import(/* webpackChunkName: "about" */ '../views/Group_chat.vue'),
    meta: {
      showHeader: true,
    },
  },
  {
    path: '/takequiz',
    name: 'Take A Quiz',
   
    component: () => import(/* webpackChunkName: "about" */ '../views/Take_quiz.vue'),
    meta: {
      showHeader: true,
    },
  },
  
  {
    path: '/lectureshare',
    name: 'Lecture Share',
   
    component: () => import(/* webpackChunkName: "about" */ '../views/Lecture_share.vue'),
    meta: {
      showHeader: true,
    },
  },
  {
    path: '/quizebank',
    name: 'Quize bank',
   
    component: () => import(/* webpackChunkName: "about" */ '../views/Quize_bank.vue'),
    meta: {
      showHeader: true,
    },
  },
  {
    path: '/yearbook/',
    name: 'Year Book',
   
   component: yearbookRouter,
    meta: {
      showHeader: true,
    },
    children: [
      {
        path: '',
        component: yearbook,
        meta: {
          showHeader: true,
          requiresAuth: true,
        },
      },
     
      {
        path: ':id',
        name: 'Class',
        component: yeabookClass,
        props: true,
        meta: {
          showHeader: true,
          requiresAuth: true,
        },
      },
    ]
  
  },
  {
    path: '/notifications',
    name: 'Notifications',
   
    component: () => import(/* webpackChunkName: "about" */ '../views/Notification'),
    meta: {
      showHeader: true,
    },
  },
  {
    path: '/option',
    name: 'firstScreen',
   
    component: () => import(/* webpackChunkName: "about" */ '../views/option_screen.vue'),
    meta: {
      showHeader: false,
    },
  },
  {
    path: '/settings',
    name: 'Settings',
   
    component: () => import(/* webpackChunkName: "settings" */ '../views/Settings.vue'),
    meta: {
      showHeader: true,
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
